/** @format */

import React, {
  createContext,
  useContext,
  useEffect,
  useReducer,
  useState,
} from "react";
import { useNavigate } from "react-router-dom";
import { authReducer, ACTIONS } from "../reducer/authReducer";
import { auth, doc, db, getDoc } from "../firebase/utils";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  signInWithPopup,
  GoogleAuthProvider,
  onAuthStateChanged,
} from "firebase/auth";

const AuthContext = createContext({
  currentUser: null,
  registerNewUser: () => Promise,
  loginUser: () => Promise,
  logOutUser: () => Promise,
  googleSignIn: () => Promise,
  showModal: null,
  setShowModal: () => {},
});

export const useAuth = () => useContext(AuthContext);

const AuthContextProvider = ({ children }) => {
  //Default values for useReducer
  const defaultValues = {
    loginPopupState: false,
    signupPopupState: false,
    adminLoginPopupState: false,
    toastObject: {
      toast: null,
      toastText: "",
      toastBg: "",
    },
  };

  const navigate = useNavigate();

  const [authState, dispatch] = useReducer(authReducer, defaultValues);

  const [currentUser, setCurrentUser] = useState(null);

  const [profilePic, setProfilePic] = useState(null);

  const [backButton, setBackButton] = useState(null);

  const [showModal, setShowModal] = useState(null);

  useEffect(() => {}, [currentUser]);

  const registerNewUser = (auth, email, password) => {
    return createUserWithEmailAndPassword(auth, email, password);
  };

  const loginUser = (auth, email, password) => {
    return signInWithEmailAndPassword(auth, email, password);
  };

  const googleSignIn = () => {
    const provider = new GoogleAuthProvider();
    return signInWithPopup(auth, provider);
  };

  useEffect(() => {
    const unSubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
    });

    return () => {
      console.log("unsubcribing...", currentUser);
      unSubscribe();
    };
  }, []);

  const logOutUser = () => {
    return signOut(auth).then((res) => console.log("user signed out"));
  };

  //Hide and Show Login and Signin Popup

  const handleShowLoginPopup = () => {
    dispatch({ type: ACTIONS.SHOW_LOGIN_POPUP });
  };

  const handleShowAdminLoginPopup = () => {
    dispatch({ type: ACTIONS.SHOW_ADMIN_LOGIN_POPUP });
  };

  const handleShowSignupPopup = () => {
    dispatch({ type: ACTIONS.SHOW_SIGNUP_POPUP });
  };

  const handleHidePopup = () => {
    dispatch({ type: ACTIONS.HIDE_POPUP });
  };

  const closeToast = () => {
    setTimeout(() => {
      return dispatch({ type: ACTIONS.SET_TOAST_NULL });
    }, 3000);
  };

  //this funstion handles data used on the profile page
  const handleShowProfile = async (id) => {
    const docRef = doc(db, "users", currentUser?.uid, "students", id);
    let document = [];

    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      document.push(docSnap.data());
      sessionStorage.setItem("showProfile", JSON.stringify(...document));
      //we saved the data on the browser storage because of browser reload/refresh
      //i.e. we get our data from firebase, then save it on the storage
      //then we pull our data from the storage
      navigate("/profile");
    } else {
      // doc.data() will be undefined in this case
      console.log("No such document!");
    }
  };
  const value = {
    registerNewUser,
    loginUser,
    googleSignIn,
    logOutUser,
    authState,
    dispatch,
    handleShowLoginPopup,
    handleShowAdminLoginPopup,
    handleShowSignupPopup,
    handleHidePopup,
    closeToast,
    currentUser,
    profilePic,
    setProfilePic,
    handleShowProfile,
    backButton,
    setBackButton,
    showModal,
    setShowModal,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthContextProvider;
